import CustomButton from "../../../common/CustomButton";

function VPTFooterButton({
    title = "",
    action = () => {}
}) {
    return (
        <div id="v-pt-footer">
            <CustomButton className="active" onClick={action}>{title}</CustomButton>
        </div>
    );
}

export default VPTFooterButton;